import { render, staticRenderFns } from "./OpportunityList.vue?vue&type=template&id=2b3f7191&"
import script from "./OpportunityList.vue?vue&type=script&lang=js&"
export * from "./OpportunityList.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports